<template>
  <div v-if="isLoading">
    <div class="text-center text-danger screen-center">
      <div class="align-middle spinner-bubble spinner-bubble-danger mr-5"></div>
      <strong>Cargando...</strong>
    </div>
  </div>
  <div v-else>
    <div class="row mb-4">
      <div class="col-sm-12 mb-4">
        <div class="card text-left">
          <div class="card-header">
            <div class="row">
              <div class="col-sm-4 d-flex align-items-center">
                <div class="breadcrumb mb-2 custom-top-padding mr-3">
                  <h4 class="mb-0"><strong>Orden de Trabajo</strong></h4>
                </div>
              </div>
              <div class="col-sm-4 offset-sm-4">
                <div class="text-right d-flex align-items-center justify-content-end">
                   <input type="text" class="form-control"
                  v-model="busqueda"
                  autocomplete="off"
                  placeholder="Buscar"
                  style="max-width: 220px;"
                  @keyup="filtrarBusqueda">
                  <label class="switch switch-success mr-3">
                    <input type="checkbox" id="filter"
                      :checked="estado"
                      v-model="estado"
                      @change="getData">
                    <span class="slider"></span>
                    <span>{{ labelActivos }}</span>
                  </label>
                  <button class="btn btn-info btn-responsive">
                    Atendidos
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row mb-3"
              >
              <div class="col-3 p-3"
                v-for="(item, index) in listaTablas"
                :key="index"
                :id="item.orden_id"
                :item="item">
                <div class="p-3 bg-gray border-radius"
                  @click="goToDoctor(item.medico_id)"
                  style="cursor: pointer;">
                  <div class="row">
                    <div class="col-5">
                      <div class="logo">
                        <img v-if="item.imagen_medico"
                          class="logo-img"
                          :src="item.imagen_medico">
                        <div v-else class="placeholder-img">
                          <i class="i-Administrator" style="font-size: 40px; color: #999;"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-7 small-content">
                      <div class="pl-0 turno">
                      </div>
                      <div class="small-content text-right" style="font-size:11px;
                        margin-block-start: auto; color: gray;">
                        <strong style="color: green;">Atendido: 0 </strong>
                        <br>
                        <strong style="color: red;">Pendiente:
                          {{ item.total_cantidad_pendiente ? item.total_cantidad_pendiente : 0 }}
                        </strong>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-12">
                      <strong> {{ item.medico }} </strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Controles de paginación y búsqueda -->
            <div class="row mb-2">
              <div class="col-sm-3">
                <div class="btn-group">
                  <span class="pt-2 mr-1">Mostrar </span>
                  <b-form-select v-model="porPagina"
                    :options="paginaOpciones"
                    @change="getData">
                  </b-form-select>
                  <span class="pt-2 ml-1"> Registros</span>
                </div>
              </div>
            </div>

            <!-- Lista de órdenes de trabajo -->
            <div class="row">
              <div class="col-sm-8">
                <button
                  class="btn btn-success mt-2 mr-2 px-2 py-1"
                  style="font-size: 0.75rem"
                  :disabled="true"
                >
                  <i
                    class="nav-icon i-Eye"
                    style="font-size: 0.85rem; cursor: pointer"
                    @click="gotToOrden()"
                  ></i>
                </button>
                </div>
              <div class="col-sm-4">
                <b-pagination
                  v-model="paginaActual"
                  :total-rows="totalFilas"
                  :per-page="porPagina"
                  class="my-0 float-right"
                  @input="getData"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from '@/modules/common/axiosERP';
import { util } from '@/plugins/util';

export default {
  name: 'index',
  components: {
  },
  data() {
    return {
      busqueda: null,
      delayTimeout: null,
      estado: true,
      paginaActual: 1,
      totalFilas: 0,
      porPagina: 24,
      paginaOpciones: [24, 48, 96],
      listaTablas: [],
      medicos: [],
      isLoading: true,
    };
  },
  async created() {
    await this.getData();
    this.isLoading = false;
  },
  methods: {
    async getData() {
      try {
        const REQUEST = {
          state: this.estado,
          filter_key: this.busqueda,
          page: this.paginaActual,
          per_page: this.porPagina,
        };
        const RESPONSE = await axios.get('/clinic/orden_trabajo/doctor', {
          params: REQUEST,
        });
        this.listaTablas = RESPONSE.data.data.data;
        this.totalFilas = RESPONSE.data.data.total;
      } catch (error) {
        util.showNotify(error.response.data.message, 'error');
      } finally {
        this.isLoading = false;
      }
    },
    filtrarBusqueda() {
      const DELAY = 400;
      clearTimeout(this.delayTimeout);
      this.delayTimeout = setTimeout(this.getData, DELAY);
    },
    gotToOrden() {
      this.$router.push({ name: 'orden-trabajo-form1', params: { id: this.encrypt(1) } });
    },
    goToForm1(id) {
      this.$router.push({ name: 'orden-trabajo-medico', params: { id: this.encrypt(id) } });
    },
    goToDoctor(id) {
      // Navegar a la vista del doctor
      this.$router.push({ name: 'orden-trabajo-doctor', params: { id: this.encrypt(id) } });
    },
    encrypt(id) {
      return btoa(id);
    },
    nombreEspecialidad(especialidades) {
      let nombre = '';
      especialidades.forEach((ele, index) => {
        if (index === 0) {
          nombre = ele.especialidad;
        } else {
          nombre = `${nombre}, ${ele.especialidad}`;
        }
      });
      return nombre;
    },
  },
  computed: {
    labelActivos() {
      if (this.estado) {
        return 'Activos';
      }
      return 'Inactivos';
    },
  },
};
</script>

<style scoped>
.custom-top-padding {
  padding-top: 5.53px;
}
.bg-gray {
  background-color: rgba(232, 232, 232, 0.971);
}
.border-radius {
  border-radius: 10px;
}
.logo {
  margin: 0;
  margin-left: auto;
  display: block;
  width: 80px;
  height: 80px;
}
.logo-img {
  border-radius: 50%;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.placeholder-img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.turno {
  color: green;
  white-space: nowrap;
  font-size: 8px;
}
@media (max-width: 1222px) {
  .small-content {
    padding-left: 0px;
    padding-right: 0px;
  }
  .turno {
    font-size: 8px;
    white-space: normal;
  }
  .btn-responsive {
    font-size: 11px;
  }
}
</style>
